import { render, staticRenderFns } from "./CertificateStep3.vue?vue&type=template&id=3182de08&scoped=true&"
import script from "./CertificateStep3.vue?vue&type=script&lang=js&"
export * from "./CertificateStep3.vue?vue&type=script&lang=js&"
import style0 from "./CertificateStep3.vue?vue&type=style&index=0&id=3182de08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3182de08",
  null
  
)

export default component.exports